import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/apps/app.service';
import { SessionService } from 'src/app/session.service';
import { UiService } from 'src/app/ui/ui.service';
import { UtilService } from 'src/app/util/util.service';

@Component({
  selector: 'app-view-audience',
  templateUrl: './view-audience.component.html',
  styleUrls: ['./view-audience.component.scss']
})
export class ViewAudienceComponent implements OnInit {

  audience: any;
  geofences: any;
  beaconRegions: any;
  audienceCount: string = "-";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public uiSvc: UiService,
    private appSvc: AppService,
    private sessionSvc: SessionService,
    private utilSvc: UtilService,
  ) {}

  ngOnInit(): void {
    this.audience = this.route.snapshot.data.audience;
    this.geofences = this.route.snapshot.data.geofences;
    this.beaconRegions = this.route.snapshot.data.beaconRegions;
    this.getCount();
  }

  editAudience() {
    this.router.navigate(["broadcasts", "audiences", this.audience.id]);
  }

  get currentAccount() {
    return this.sessionSvc.currentAccountValue!;
  }

  get currentApp() {
    return this.sessionSvc.currentAppValue!;
  }

  get facilities() {
    return this.sessionSvc.facilitiesValue!;
  }

  get filterObj() {
    return {
      facility_id: this.facilities.map((facility) => facility.id),
      filter: this.audience,
    };
  }

  formatDate = (date: Date) => {
    return this.utilSvc.formatDate(date);
  }

  getCount() {
    this.appSvc.getFilterCount(
      this.currentAccount.accountID,
      this.currentApp.id,
      this.filterObj,
    )
      .subscribe(
        (res: any) => {
          this.audienceCount = res.count;
        },
        (err) => {
          this.audienceCount = "n/a";
        },
      );
  }

}
